import type { GameState } from '../api/types';

/** お題の解禁まで、あと何件スポットをクリアすればよいか（024）。解禁済み・設定なしなら 0 */
export function promptsLockRemaining(s: GameState | null): number {
  if (!s) return 0;
  const need = s.event.prompts_unlock_spots ?? 0;
  return Math.max(0, need - (s.team.spot_clears ?? 0));
}
